import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";
import _imports_0 from '@/assets/discuss/empty.png';
var _hoisted_1 = {
  class: "resource-contanier"
};
var _hoisted_2 = {
  class: "top-box"
};
var _hoisted_3 = {
  class: "recommend-top"
};
var _hoisted_4 = {
  key: 0,
  class: "resource-list"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "item-cover"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  class: "right-content"
};
var _hoisted_10 = {
  class: "title"
};
var _hoisted_11 = {
  class: "info"
};
var _hoisted_12 = {
  class: "name"
};
var _hoisted_13 = {
  class: "bottom"
};
var _hoisted_14 = {
  class: "school"
};
var _hoisted_15 = {
  class: "icons-box"
};
var _hoisted_16 = {
  key: 1,
  class: "empty-box"
};
var _hoisted_17 = {
  key: 1,
  class: "empty-box loading-box"
};
var _hoisted_18 = {
  key: 1,
  class: "empty-box empty"
};
import FilePreviewDialog from 'hxhy-file-preview';
import { ChevronRightDoubleIcon } from 'tdesign-icons-vue-next';
import { env_name, escape2Html } from '@/util/util.js';
import { getFileCover } from '@/util/index';
import { imgCoverMap } from '@/utils/index';
import { routeAuth } from '@/utils/auth';
import { getStore } from '@/util/store';
import { ref, onMounted } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { collectResource, collectCourse, copyResource, copyCourse, getRecommendList } from '@/api/index-bei';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var defaultImage = require("@/assets/course/big.svg");
    var TYPE_LIST = [{
      label: '课程',
      value: 'curriculum'
    }, {
      label: '学程',
      value: 'course'
    }, {
      label: '素材',
      value: 'material'
    }, {
      label: '习题',
      value: 'exercise'
    }];
    var resourceType = ref('course');
    var query = ref('');
    var list = ref([]); // 推荐资源列表
    var listLoading = ref(false); // 推荐资源列表loading

    // 权限检测
    var canUseFlag = ref(false);
    var canCollFlag = ref(false);
    var schoolSource = ref(false);
    var geCollAuth = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var inspiration, learn, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return routeAuth('schoolSourceLib');
            case 1:
              schoolSource.value = _context.v;
              _context.n = 2;
              return routeAuth('inspirationCentre');
            case 2:
              inspiration = _context.v;
              _context.n = 3;
              return routeAuth('learnCentre');
            case 3:
              learn = _context.v;
              if (inspiration) {
                canUseFlag.value = true;
              }
              if (inspiration || learn) {
                canCollFlag.value = true;
              }
              console.log(inspiration, learn, schoolSource.value, '---schoolSource.value');
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              console.log(_t);
              MessagePlugin.error('获取必要权限异常，将不能收藏或引用');
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[0, 4]]);
      }));
      return function geCollAuth() {
        return _ref.apply(this, arguments);
      };
    }();

    // 获取推荐资源列表
    var getList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              listLoading.value = true;
              _context2.p = 1;
              _context2.n = 2;
              return getRecommendList();
            case 2:
              res = _context2.v;
              list.value = res.data.data;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              (_t2 === null || _t2 === void 0 ? void 0 : _t2.message) && MessagePlugin.warning(_t2 === null || _t2 === void 0 ? void 0 : _t2.message);
            case 4:
              _context2.p = 4;
              listLoading.value = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3, 4, 5]]);
      }));
      return function getList() {
        return _ref2.apply(this, arguments);
      };
    }();
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return geCollAuth();
          case 1:
            schoolSource.value && getList();
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    })));
    // 跳转校本库资源搜索/跳转校本库应用
    var toSearch = function toSearch(type) {
      var commonName = env_name ? "//".concat(env_name, "web.zhixuehuijiao.cn") : '//web.zhixuehuijiao.cn';
      if (type === 'app') {
        window.open("".concat(commonName, "/schoolSourceLib?schoolSourceLib=%2FschoolSource"));
      } else {
        window.open("".concat(commonName, "/schoolSourceLib?schoolSourceLib=%2FschoolSource?token=").concat(accessInfo.access_token, "&query=").concat(query.value, "&resourceType=").concat(resourceType.value));
      }
    };
    /**
     * 预览
     */
    var accessInfo = getStore({
      name: 'accessInfo'
    }); // 获取accessInfo
    var newResourceVisible = ref(false); // 新素材预览弹窗
    var filePath = ref(''); // 新素材预览弹窗文件路径
    var sourceId = ref(''); // 新素材预览资源id
    var sourceName = ref(''); // 新素材预览资源名称
    var token = ref(getStore({
      name: 'access_token'
    }));
    var showDetail = function showDetail(item) {
      if (Number(item.sourceType) === 1) {
        if (item.courseVersion === 2) {
          // 新学程预览
          var queryUrl = "/preview?courseId=".concat(item.id, "&version=2&token=").concat(accessInfo.access_token);
          var url = env_name ? "//".concat(env_name, "course.zhixuehuijiao.cn").concat(queryUrl) : "//edu-course.zhixuehuijiao.cn".concat(queryUrl);
          window.open(url);
        } else {
          // 旧学程预览
          window.open("/courseDetail?id=".concat(item.id, "&source=").concat(item.resourceSource || 2, "&accountType=").concat(accessInfo === null || accessInfo === void 0 ? void 0 : accessInfo.accountType));
        }
      } else {
        // 素材预览
        filePath.value = item.url || '';
        sourceId.value = !filePath.value ? item.id : '';
        sourceName.value = item.name || '';
        newResourceVisible.value = true;
      }
    };
    /**
     * 收藏取消收藏
     */
    var handleCollect = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(item) {
        var res, obj;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(Number(item.sourceType) === 2)) {
                _context4.n = 2;
                break;
              }
              // 素材收藏
              obj = {
                id: item.id,
                type: item.resourceSource,
                // 4、校本库 8、集团库
                operationType: item.isColl ? 1 : 0,
                schoolId: item.reportPersonSchoolId,
                schoolName: item.reportPersonSchoolName
              };
              _context4.n = 1;
              return collectResource(obj);
            case 1:
              res = _context4.v;
              _context4.n = 4;
              break;
            case 2:
              _context4.n = 3;
              return collectCourse(item.id);
            case 3:
              res = _context4.v;
            case 4:
              if (res.data.code === 0) {
                MessagePlugin.closeAll();
                MessagePlugin.success("".concat(item.isColl ? '取消收藏成功！' : '收藏成功！'));
                item.isColl = !item.isColl;
              }
            case 5:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function handleCollect(_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    /**
     * 引用
     */
    var handleCopy = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(id, source, type) {
        var copyObj, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              copyObj = {
                2: function _(id, source) {
                  return copyResource(id, source);
                },
                1: function _(id) {
                  return copyCourse(id);
                }
              };
              _context5.n = 1;
              return copyObj[type](id, source);
            case 1:
              res = _context5.v;
              if (res.data.code === 0) {
                MessagePlugin.closeAll();
                MessagePlugin.success('已引用至创作中心');
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }));
      return function handleCopy(_x2, _x3, _x4) {
        return _ref5.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_t_select = _resolveComponent("t-select");
      var _component_t_input = _resolveComponent("t-input");
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_input_adornment = _resolveComponent("t-input-adornment");
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_Loading = _resolveComponent("Loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [schoolSource.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_2, [_cache[7] || (_cache[7] = _createElementVNode("h2", null, "校本库", -1)), _createVNode(_component_t_input_adornment, {
        class: "adornment"
      }, {
        prepend: _withCtx(function () {
          return [_createVNode(_component_t_select, {
            autoWidth: "",
            modelValue: resourceType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return resourceType.value = $event;
            }),
            options: TYPE_LIST
          }, null, 8, ["modelValue"])];
        }),
        append: _withCtx(function () {
          return [_createVNode(_component_t_button, {
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return toSearch('search');
            })
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode("搜索", -1)]));
            }),
            _: 1
          })];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_t_input, {
            modelValue: query.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return query.value = $event;
            }),
            placeholder: ""
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }), _createElementVNode("div", {
        class: "to-school-btn",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return toSearch('app');
        })
      }, [_cache[6] || (_cache[6] = _createTextVNode(" 点击前往按条件筛选资源 ", -1)), _createVNode(_unref(ChevronRightDoubleIcon), {
        class: "icon"
      })])]), _createElementVNode("div", _hoisted_3, [_cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "recommend-title"
      }, "推荐资源", -1)), _createElementVNode("div", {
        class: "btn-refresh",
        onClick: getList
      }, [_createVNode(_component_svg_icon, {
        class: "icon-refresh",
        name: "course-refresh",
        size: "16"
      }), _cache[8] || (_cache[8] = _createTextVNode(" 换一换 ", -1))])]), !listLoading.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [list.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: index,
          onClick: function onClick($event) {
            return showDetail(item);
          }
        }, [_createElementVNode("div", _hoisted_6, [Number(item.sourceType) === 2 ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "cover-img",
          src: item.formatType && _unref(imgCoverMap)[_unref(getFileCover)(item.formatType)]
        }, null, 8, _hoisted_7)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [item.coverUrl ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: item.coverUrl,
          class: "cover-img"
        }, null, 8, _hoisted_8)) : (_openBlock(), _createBlock(_component_svg_icon, {
          key: 1,
          width: "72px",
          height: "96px",
          name: "big"
        }))], 64))]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(item.name && _unref(escape2Html)(item.name) || '暂无标题'), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(item.creatorName), 1), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(item.reportPersonSchoolName), 1), _createElementVNode("div", _hoisted_15, [canCollFlag.value ? (_openBlock(), _createBlock(_component_svg_icon, {
          key: 0,
          class: "collect-icon",
          name: item.isColl ? 'collected' : 'unCollect',
          size: "22",
          onClick: _withModifiers(function ($event) {
            return handleCollect(item);
          }, ["stop"])
        }, null, 8, ["name", "onClick"])) : _createCommentVNode("", true), canUseFlag.value ? (_openBlock(), _createBlock(_component_svg_icon, {
          key: 1,
          name: "use",
          size: "22",
          onClick: _withModifiers(function ($event) {
            return handleCopy(item.id, item.resourceSource || 2, Number(item.sourceType));
          }, ["stop"])
        }, null, 8, ["onClick"])) : _createCommentVNode("", true)])])])])], 8, _hoisted_5);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_svg_icon, {
        name: "empty-table",
        size: "120"
      })]))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_Loading), _cache[10] || (_cache[10] = _createElementVNode("span", null, "加载中...", -1))]))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_18, _toConsumableArray(_cache[11] || (_cache[11] = [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1), _createElementVNode("span", null, "暂无应用权限", -1)])))), newResourceVisible.value ? (_openBlock(), _createBlock(_unref(FilePreviewDialog), {
        key: 2,
        modelValue: newResourceVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return newResourceVisible.value = $event;
        }),
        path: filePath.value,
        "source-id": sourceId.value,
        "source-name": sourceName.value,
        token: token.value
      }, null, 8, ["modelValue", "path", "source-id", "source-name", "token"])) : _createCommentVNode("", true)]);
    };
  }
};